import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useAgentRuns = (threadId: string | null, status?: string) => {
  const fetcher = async () => {
    if (!threadId) return [];
    return await AgentService.getAgentRuns(threadId, status);
  };

  const { data, error, isLoading, mutate } = useSWR(
    threadId ? ["agent", "agentRuns", threadId, status] : null,
    fetcher,
    defaultSWROption,
  );

  return {
    agentRuns: data ?? [],
    error,
    isLoading,
    mutate,
  };
};
